import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    async setZIndex(element = this.element) {
        await this.setZIndexManager()
        this.zIndexManager.setZIndex(element)
    }

    async setZIndexManager() {
        const zIndexManagerControllerName = 'views--components--global--z-index-manager'
        const el = document.querySelector(`[data-controller="${zIndexManagerControllerName}"]`)
        this.zIndexManager = this.application.getControllerForElementAndIdentifier(
            el,
            zIndexManagerControllerName
        )
    }
}
